<div class="bell-wrapper">
  <button
    pButton
    pRipple
    type="button"
    icon="pi pi-bell"
    class="p-button-rounded p-button-text-title bell-button"
    [attr.aria-label]="ariaLabel"
    (click)="openPanel($event)">
  </button>
  <p-badge
    *ngIf="unreadCount > 0"
    [value]="badgeLabel"
    severity="danger"
    size="small">
  </p-badge>

  <p-overlayPanel #notifPanel [dismissable]="true" appendTo="body" styleClass="np-panel">

    <!-- Header -->
    <div class="np-header">
      <span class="np-title">Notifications</span>
      <button
        pButton
        pRipple
        type="button"
        label="Mark all as read"
        class="p-button-text p-button-sm np-mark-all-btn"
        (click)="onMarkAllAsRead()">
      </button>
    </div>

    <!-- Only show unread toggle -->
    <div class="np-filter-row">
      <span class="np-filter-label">Only show unread</span>
      <p-inputSwitch [(ngModel)]="onlyUnread" styleClass="np-toggle"></p-inputSwitch>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="np-loading">
      <p-progressSpinner
        strokeWidth="3"
        [style]="{ width: '32px', height: '32px' }">
      </p-progressSpinner>
    </div>

    <!-- Empty state -->
    <div *ngIf="!loading && displayedNotifications.length === 0" class="np-empty">
      <i class="pi pi-bell np-empty-icon"></i>
      <p class="np-empty-title">You're all caught up!</p>
      <p class="np-empty-sub">No notifications to show.</p>
    </div>

    <!-- Notification list -->
    <div *ngIf="!loading && displayedNotifications.length > 0" class="np-list">
      <div
        *ngFor="let n of displayedNotifications"
        class="np-item"
        [class.np-item--unread]="!n.isRead"
        (click)="onNotificationClick(n)">

        <!-- Type icon -->
        <div class="np-item-icon" [ngClass]="typeConfig(n.type).bgClass">
          <i [class]="typeConfig(n.type).icon"></i>
        </div>

        <!-- Content -->
        <div class="np-item-body">
          <div class="np-item-name">{{ n.name }}</div>
          <div class="np-item-desc">{{ n.description }}</div>
        </div>

        <!-- Meta: badge + time + read dot + dismiss -->
        <div class="np-item-meta">
          <span class="np-type-badge" [ngClass]="typeConfig(n.type).badgeClass">
            {{ typeConfig(n.type).label }}
          </span>
          <span class="np-time">{{ timeAgo(n.createdAt) }}</span>
          <span class="np-read-dot" [class.np-read-dot--unread]="!n.isRead"></span>
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-times"
            class="p-button-rounded p-button-text p-button-sm np-dismiss-btn"
            aria-label="Dismiss"
            (click)="onDismiss(n, $event)">
          </button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="np-footer">
      <a
        class="np-view-all"
        [routerLink]="['/notifications']"
        (click)="notifPanel.hide()">
        View all notifications <i class="pi pi-chevron-right"></i>
      </a>
    </div>

  </p-overlayPanel>
</div>
